export const shadows = {
  1: '0px 0px 2px rgba(106, 190, 74, .2)',
  2: '0px 0px 2px rgba(0, 0, 0, .2)',
  3: '0px 3px 3px -2px rgb(0 0 0 / 20%), 0px 3px 4px 0px rgb(0 0 0 / 14%), 0px 1px 8px 0px rgb(0 0 0 / 12%)',
  4: '0px 0px 2px rgba(0, 0, 0, .2)',
};
